export const navItems = [
  {
    id: "001",
    title: "About",
    link: "/resume/about",
  },
  {
    id: "002",
    title: "Skills",
    link: "/resume/skills",
  },
  {
    id: "003",
    title: "Work History",
    link: "/resume/workhistory",
  },
  {
    id: "004",
    title: "Projects",
    link: "/resume/projects",
  },
  {
    id: "005",
    title: "Contact",
    link: "/resume/contact",
  },
]

export const codeProjects = [
  {
    id: "001",
    title: "Code Project 001",
    description:
      "Climb leg rub face on everything give attitude nap all day for under the bed. Chase mice attack feet but rub face on everything hopped up",
    client: "Metawerks",
    skills: ["Design", "JS"],
    tools: ["VS Code", "Vue"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "002",
    title: "Code Project 002",
    description:
      "Climb leg rub face on everything give attitude nap all day for under the bed. Chase mice attack feet but rub face on everything hopped up",
    client: "PDI",
    skills: ["JQuery", "JS", "HTML", "CSS"],
    tools: ["Atom", "Sketch"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "003",
    title: "Code Project 003",
    description:
      "Climb leg rub face on everything give attitude nap all day for under the bed. Chase mice attack feet but rub face on everything hopped up",
    client: "PDI",
    skills: ["JQuery", "JS", "HTML", "CSS"],
    tools: ["Atom", "Sketch"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "002",
    title: "Code Project 004",
    description:
      "Climb leg rub face on everything give attitude nap all day for under the bed. Chase mice attack feet but rub face on everything hopped up",
    client: "PDI",
    skills: ["JQuery", "JS", "HTML", "CSS"],
    tools: ["Atom", "Sketch"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
]

export const designProjects = [
  {
    id: "003",
    title: "Design Project 001",
    description:
      "Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas.",
    client: "Metawerks",
    skills: ["Design", "Color Theory"],
    tools: ["Adobe Photoshop", "Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "004",
    title: "Design Project 002",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "005",
    title: "Design Project 003",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "006",
    title: "Design Project 004",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "003",
    title: "Design Project 001",
    description:
      "Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas.",
    client: "Metawerks",
    skills: ["Design", "Color Theory"],
    tools: ["Adobe Photoshop", "Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "004",
    title: "Design Project 002",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "005",
    title: "Design Project 003",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "006",
    title: "Design Project 004",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "003",
    title: "Design Project 001",
    description:
      "Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas.",
    client: "Metawerks",
    skills: ["Design", "Color Theory"],
    tools: ["Adobe Photoshop", "Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "004",
    title: "Design Project 002",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "005",
    title: "Design Project 003",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
  {
    id: "006",
    title: "Design Project 004",
    description:
      "Lorem ipsizzle dolor sit amet, yo mamma yo mamma elit. Fizzle sapizzle velizzle, fo shizzle my nizzle volutpat, suscipit quis, vel, dope. Pellentesque daahng dawg tortizzle. Sed erizzle. Fusce shiz fizzle dapibizzle da bomb tempus mofo. Mauris doggy nibh izzle turpizzle. Yo mamma izzle yo mamma. Pellentesque crackalackin rhoncizzle check out this. In yippiyo dang platea dictumst. I'm in the shizzle dapibizzle. Curabitizzle tellus urna, pretizzle eu, ghetto ac, ma nizzle vitae, nunc. Black suscipizzle. ",
    client: "Hive Records",
    skills: ["Design", "Print Production"],
    tools: ["Adobe Illustrator"],
    thumbnail: "http://placekitten.com/400/200",
    image: "",
  },
]

export const numbers = [
  {
    id: "001",
  },
  {
    id: "002",
  },
  {
    id: "003",
  },
  {
    id: "004",
  },
  {
    id: "005",
  },
  {
    id: "006",
  },
  {
    id: "007",
  },
  {
    id: "008",
  },
  {
    id: "009",
  },
  {
    id: "010",
  },
]

export const jobz = [
  {
    id: "001",
    company: "PDI Software",
    tenure: "3 years 4 months",
    fullDate: "March 2018 - Present",
    logo: "../img/logo-pdi.svg",
    logoDark: "../img/logo-pdi-dark.svg",
    roles: [
      {
        id: "001",
        title: "Director, CRM Ops & Interactive Services",
        date: "June 2021 - Present",
        descriptions: [
          "Managed up to 6 direct reports and full team of up to 16 FTEs.",
          "Responsible for multi-channel execution and delivery of App UI Design, App Front-End Code, Web Front-End Code, POP Signage Template Code, Email Template Code and CRM Campaign Deployment.",
          "Assisted teams in planning and migration to new project management platform.",
          "Concepted production strategy and templating approach for white label email design & development.",
        ],
        tags: ["Production", "Management"],
      },
      {
        id: "002",
        title: "Director, Interactive Services",
        date: "Feb 2020 - June 2021",
        descriptions: [
          "Managed up to 5 direct reports and full team of up to 12 FTEs",
          "Responsible for multi-channel execution and delivery of App UI Design, App Front-End Code, Web Front-End Code, POP Signage Template Code, and Email Template Code",
          "Created design system & library for white label loyalty apps. Improved one week turnaround time to half day or less turnaround time.",
          "Advise on best practices and approach for UI/UX design, front-end coding, and production asset delivery.",
        ],
        tags: ["UI/UX", "App", "Email", "Web", "Performance"],
      },
      {
        id: "003",
        title: "Director, Creative & Interactive Services",
        date: "Mar 2018 - June 2020",
        descriptions: ["Same role as previous - Excentus aquired by PDI"],
        tags: ["UI/UX", "App", "Email", "Web", "Performance"],
      },
    ],
  },
  {
    id: "002",
    company: "Excentus",
    tenure: "6 years",
    fullDate: "April 2012 - March 2018",
    logo: "../img/logo-excentus.svg",
    logoDark: "../img/logo-excentus-dark.svg",
    roles: [
      {
        id: "003",
        title: "Director, Creative & Interactive Services",
        date: "May 2017 - Mar 2018",
        descriptions: [
          "Managed team of up to 8 FTEs",
          "Responsible for multi-channel execution and delivery of App UI Design, App Front-End Code, Web Design, Web Front-End Code, POP Signage Design, POP Signage Template Code, Email Design, and Email Template Code",
          "Created semi-automated workflow for processing offer images. Leverage Photoshop Scripting and Command-line task to reduce time and increase efficiency ",
        ],
        tags: ["UI/UX", "App", "Email", "Web", "Performance"],
      },
      {
        id: "004",
        title: "UX Designer",
        date: "Feb 2016 - May 2017",
        descriptions: [
          "Contiued UI/UX work for Fuel Reward app features",
          "UI/UX design for web portals, software, and loyalty program apps",
        ],
        tags: ["UI", "App", "Email", "Web", "Performance"],
      },
      {
        id: "005",
        title: "Interactive UX Design Manager",
        date: "Sep 2014 - Feb 2016",
        descriptions: [
          "Desgined an updated UX/UI for fuelrewards.com",
          "Participate in rapid iterative prototyping excercise with Usability Sciences to measure effectiveness of revised web UX",
          "UI/UX design updates for Fuel Rewards app & features",
          "Lead Creative Team responsible for design and devlopment projects",
        ],
        tags: [
          "UI",
          "Code",
          "App",
          "Email",
          "Web",
          "User Testing",
          "Management",
        ],
      },
      {
        id: "006",
        title: "Sr. UI/UX Developer",
        date: "Feb 2014 - Sep 2014",
        descriptions: [
          "Front-end design and code enhancements for Fuel Rewards website",
          "Added responsive behavior to fuelrewards.com",
          "Fuel Rewards Branding Refresh",
        ],
        tags: ["Web", "Email", "App", "Design", "Code", "Team Lead"],
      },
      {
        id: "007",
        title: "Creative Services Manager",
        date: "Sep 2013 - Feb 2014",
        descriptions: [
          "Manage team of designers and front-end coders responsible for email and web communication channels",
          "Design web and email graphics and UIs",
          "Manage web-content for Fuel Reward program and affiliate  partners with Magnolia CMS",
          "Advise and facilitate migration from Salesforce to ClickSquared ESP",
        ],
        tags: ["Web", "Email", "Design", "Code", "Team Lead"],
      },
      {
        id: "008",
        title: "Email Marketing Specialist",
        date: "Apr 2012 - Sep 2013",
        descriptions: [
          "Design and code email templates for the Fuel Rewards<sup>&reg;</sup> program",
          "Execute email campaign sends using Salesforce platform (pre-ExactTarget)",
          "Advise Marketing team on email best sending practices",
        ],
        tags: ["Email Code", "Deliverability"],
      },
    ],
  },
  {
    id: "003",
    company: "ExactTarget",
    tenure: "6 months",
    fullDate: "Nov 2010 - Apr 2011",
    logo: "../img/logo-exacttarget.svg",
    logoDark: "../img/logo-exacttarget-dark.svg",
    roles: [
      {
        id: "001",
        title: "Sr. Production Specialist",
        date: "Nov 2010 - Apr 2011",
        descriptions: [
          "Client accounts: Oakley, Best Buy, Ally Bank, BevMo!, Disney, etc.",
          "Developed highly-dynamic email templates with focus on compatability and deliverability in accordance with industry standard best practices.",
          "Used HTML, CSS, and ExactTarget AMPScript to convert Photoshop design layouts into dynamic email templates.",
        ],
        tags: ["Email Code", "ESP", "Campaigns", "AMPScript"],
      },
    ],
  },
  {
    id: "004",
    company: "Travelocity",
    tenure: "1 year 4 months",
    fullDate: "Aug 2009 - Nov 2010",
    logo: "../img/logo-travelocity.svg",
    logoDark: "../img/logo-travelocity-dark.svg",
    roles: [
      {
        id: "001",
        title: "Email Marketing Coordinator",
        date: "Aug 2009 - Nov 2010",
        descriptions: [
          "Client Accounts: Travelocity, American Express, Disney, Universal Orlando, etc.",
          "Designed, developed, and edited dynamic HTML email templates for marketing/transactional campaigns",
          "Developed HTML email templates for Travelocity partners such as American Express, Disney, Universal Orlando, etc.",
          "Redesigned HTML templates improved click-through rates by 14%+",
          "Executed HTML email sends using StrongMail platform",
          "Performed QA checks for outgoing email campaigns within multiple email viewing programs and Return Path",
          "Utilized SQL queries to generate email content lists",
          "Worked with Travelocity divisions nationwide to coordinate updated content for weekly mailings",
        ],
        tags: ["Email Code", "ESP", "Campaigns"],
      },
    ],
  },
  {
    id: "005",
    company: "Harte-Hanks Digital Practice",
    tenure: "4 years 1 month",
    fullDate: "Aug 2005 - Aug 2009",
    logo: "../img/logo-harte-hanks.svg",
    logoDark: "../img/logo-harte-hanks-dark.svg",
    roles: [
      {
        id: "001",
        title: "Sr. Email Production Specialist",
        date: "Aug 2007 - Aug 2009",
        descriptions: [
          "All previous responsibilities",
          "Trained team of Email Production Specialists",
          "Created best practices documentation, training materials and processes for Email Production team",
          "Provided reporting and analysis from Postfuture Tracker tool and SQL database queries",
          "Worked with ISPs & third party delivery assurance services to troubleshoot/correct email deliverability issues",
          "Tested new software versions; provided recommendations to Development team for improvements and interface corrections",
        ],
        tags: ["Email Code", "ESP", "Campaigns", "Design", "Deliverability"],
      },
      {
        id: "002",
        title: "Email Production Specialist",
        date: "Aug 2005 - Aug 2007",
        descriptions: [
          "Client accounts: Best Buy, Disney, A&E, Mercedes-Benz, Office Depot, PetSmart, Jenny Craig, Armani, Pizza Hut, KFC, Microsoft, etc.",
          "Created and deployed dynamic HTML email marketing/transactional campaigns",
          "Performed QA checks for outgoing email campaigns within inboxes, Return Path, and Pivotal Veracity",
          "Created internal company web pages, information resources, and client landing pages",
          "Graphic design/editing for customer emails and Postfuture application interface",
          "Performed troubleshooting and editing of client supplied HTML/CSS creative documents",
          "List management, segmentation, and filter creation",
          "Stayed up to date on current email production techniques",
          "Promoted to Sr. Email Production Specialist",
        ],
        tags: ["Email Code", "ESP", "Design"],
      },
    ],
  },
]

export const languages = [
  {
    id: "001",
    name: "HTML",
    proficiency: "95%",
    logo: "../img/logo-html.svg",
  },
  {
    id: "001",
    name: "HTML Email",
    proficiency: "90%",
    logo: "../img/logo-html4.svg",
  },
  {
    id: "002",
    name: "CSS",
    proficiency: "95%",
    logo: "../img/logo-css.svg",
  },
  {
    id: "003",
    name: "SCSS",
    proficiency: "60%",
    logo: "../img/logo-scss.svg",
  },
  {
    id: "004",
    name: "Javascript",
    proficiency: "50%",
    logo: "../img/logo-js.svg",
  },
  {
    id: "005",
    name: "Node",
    proficiency: "90%",
    logo: "../img/logo-node.svg",
  },
  {
    id: "006",
    name: "Gulp",
    proficiency: "85%",
    logo: "../img/logo-gulp.svg",
  },
  {
    id: "007",
    name: "Nunjucks",
    proficiency: "70%",
    logo: "../img/logo-nunjucks.svg",
  },
  {
    id: "008",
    name: "Vue",
    proficiency: "30%",
    logo: "../img/logo-vue.svg",
  },
  {
    id: "009",
    name: "Wordpress",
    proficiency: "90%",
    logo: "../img/logo-wordpress.svg",
  },
  {
    id: "010",
    name: "Git",
    proficiency: "50%",
    logo: "../img/logo-git.svg",
  },
  {
    id: "011",
    name: "GitKraken",
    proficiency: "90%",
    logo: "../img/logo-gitkraken.svg",
  },
  {
    id: "012",
    name: "VS Code",
    proficiency: "95%",
    logo: "../img/logo-vscode.svg",
  },
  {
    id: "013",
    name: "FTP/CDN",
    proficiency: "98%",
    logo: "../img/logo-ftp.svg",
  },
]

export const uiSoftwares = [
  {
    id: "001",
    name: "Sketch",
    proficiency: "98%",
    logo: "../img/logo-sketch.svg",
  },
  {
    id: "002",
    name: "XD",
    proficiency: "90%",
    logo: "../img/logo-xd.svg",
  },
  {
    id: "014",
    name: "MarvelApp",
    proficiency: "99%",
    logo: "../img/logo-marvelapp.svg",
  },
]

export const designSoftwares = [
  {
    id: "003",
    name: "Photoshop",
    proficiency: "95%",
    logo: "../img/logo-photoshop.svg",
  },
  {
    id: "004",
    name: "Illustrator",
    proficiency: "95%",
    logo: "../img/logo-illustrator.svg",
  },
  {
    id: "005",
    name: "After Effects",
    proficiency: "70%",
    logo: "../img/logo-aftereffects.svg",
  },
  {
    id: "006",
    name: "Premiere",
    proficiency: "60%",
    logo: "../img/logo-premiere.svg",
  },
  {
    id: "007",
    name: "InDesign",
    proficiency: "75%",
    logo: "../img/logo-indesign.svg",
  },
]

export const productivitySoftwares = [
  {
    id: "008",
    name: "Acrobat",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-acrobat.svg",
  },

  {
    id: "011",
    name: "MS Office",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-office365.svg",
  },
  {
    id: "012",
    name: "Workspace",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-google.svg",
  },

  {
    id: "014",
    name: "Smartsheet",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-smartsheet.svg",
  },
  {
    id: "014",
    name: "Wrike",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-wrike.svg",
  },
]

export const testingSoftwares = [
  {
    id: "014",
    name: "Litmus",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-litmus.svg",
  },
  {
    id: "014",
    name: "Email on Acid",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-eoa.svg",
  },
  {
    id: "014",
    name: "HotJar",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-hotjar.svg",
  },
  {
    id: "014",
    name: "UsabilityHub",
    proficiency: "../img/icon-skill-check.svg",
    logo: "../img/logo-usabilityhub.svg",
  },
]

export const skills = [
  {
    id: "001",
    name: "Graphic Design",
    logo: "../img/icon-skill-design.svg",
    desc: "Print, Digital, Icons, Illustration, Layout, etc.",
  },
  {
    id: "002",
    name: "UI Design",
    logo: "../img/icon-skill-ui.svg",
    desc:
      "Wireframes, prototypes, high-fidelity mockups, interaction decks, design systems, production assets",
  },
  {
    id: "003",
    name: "Web Development",
    logo: "../img/icon-skill-code.svg",
    desc:
      "Repsonsive websites using traditional markup and/or modern FrontEnd frameworks.",
  },
  {
    id: "004",
    name: "Perf & Optimization",
    logo: "../img/icon-skill-perf.svg",
    desc:
      "Pagespeed & performance optimization of web assets for images, code, and more",
  },
  {
    id: "005",
    name: "Email Development",
    logo: "../img/icon-skill-email.svg",
    desc:
      "HTML email template creation, compatibility rendering across major mobile & desktop email clients.",
  },
]

export const projects = [
  {
    id: "001",
    name: "Downtime",
    slug: "downtime",
    category: ["web", "ui/ux", "graphic", "web"],
    thumb: "../img/projects/downtime-thumb@2x.png",
    imgTitle01: "Login Screen",
    imgPath01: "/img/projects/downtime-login.png",
    imgTitle02: "Filter & Sorting",
    imgPath02: "/img/projects/downtime-sorting.png",
    imgTitle03: "Edit Link",
    imgPath03: "/img/projects/downtime-edit-link.png",
    imgTitle04: "Add Link",
    imgPath04: "/img/projects/downtime-add-link.png",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Web App",
    descriptionLong:
      "Downtime is the latest iteration of a pet project created to catalog and share links for resources & best practices related to design and code. It is a CRUD interface for adding/edit/deleting links with basic user authentication.",
  },
  {
    id: "002",
    name: "ECD Tool",
    slug: "ecd",
    category: ["ui/ux", "graphic"],
    thumb: "../img/projects/ecd-ui-thumb@2x.png",
    imgTitle01: "Graphic Editor",
    imgPath01: "/img/projects/ecd-ui-borders.png",
    imgTitle02: "Color Picker",
    imgPath02: "/img/projects/ecd-ui-colorpicker.png",
    imgTitle03: "Find/Replace",
    imgPath03: "/img/projects/ecd-ui-findreplace.png",
    imgTitle04: "Find/Replace",
    imgPath04: "/img/projects/ecd-ui-prototype.png",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Software UI",
    descriptionLong:
      "Designed a UI for the Excentus Content Developer Tool - a graphical code editor for building responsive UIs that leverage API data.",
  },
  {
    id: "003",
    name: "Smitty's",
    slug: "smittys",
    category: ["web", "ui/ux", "graphic", "web", "email"],
    thumb: "../img/projects/smittys-thumb@2x.png",
    imgTitle01: "Home Screens",
    imgPath01: "/img/projects/smittys-homescreens.png",
    imgTitle02: "Store Assets",
    imgPath02: "/img/projects/smittys-storeassets.png",
    imgTitle03: "Styleguide",
    imgPath03: "/img/projects/smittys-styleguide.png",
    imgTitle04: "Symbols",
    imgPath04: "/img/projects/smittys-symbols.png",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Template System",
    descriptionLong:
      "Created a highly optimzed template system using Sketch allowing for efficient reskinning of app UIs.",
  },
  {
    id: "004",
    name: "Excentus",
    slug: "excentus-web",
    category: ["web", "ui/ux", "graphic", "web", "email", "video"],
    thumb: "../img/projects/excentus-thumb@2x.png",
    imgTitle01: "Login Screen",
    imgPath01: "/img/projects/excentus-web01.png",
    imgTitle02: "Filter & Sorting",
    imgPath02: "/img/projects/excentus-web02.png",
    imgTitle03: "Edit Link",
    imgPath03: "/img/projects/excentus-web03.png",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Website & Blog",
    descriptionLong:
      "Design, Code, and maintance for the legacy Excentus website and blog. This was created using wordpress and custom optimization node scripts and was highly tuned for pagespeed performance and security.",
  },
  {
    id: "005",
    name: "Excentus Logo",
    slug: "excentus-logo",
    category: ["web", "ui/ux", "graphic", "web", "email", "video"],
    thumb: "../img/projects/excentus-logo-thumb@2x.png",
    imgTitle01: "Primary Versions",
    imgPath01: "/img/projects/excentus-logo-01.png",
    imgTitle02: "Form Evolution",
    imgPath02: "/img/projects/excentus-logo-02.png",
    imgTitle03: "",
    imgPath03: "",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Logo Design Concepts",
    descriptionLong: "Concepts for Excentus logo & brand refresh.",
  },
  {
    id: "006",
    name: "PDIMCS Branding",
    slug: "pdimcs",
    category: ["web", "ui/ux", "graphic", "web", "email", "video"],
    thumb: "../img/projects/pdi-mcs-thumb@2x.png",
    imgTitle01: "Logo",
    imgPath01: "/img/projects/pdi-mcs-logo.png",
    imgTitle02: "Web",
    imgPath02: "/img/projects/pdi-mcs-web.png",
    imgTitle03: "Animate",
    imgPath03: "/img/projects/pdi-mcs-animate.png",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Logo & Web Design Concepts",
    descriptionLong: "Concepts for PDI MCS logo & brand refresh.",
  },

  {
    id: "007",
    name: "CCMD App Modules",
    slug: "ccmd-modules",
    category: ["web", "ui/ux", "graphic", "web", "email", "video"],
    thumb: "../img/projects/ccmd-modules-thumb@2x.png",
    imgTitle01: "Navigation Elements",
    imgPath01: "/img/projects/ccmd-modules01.png",
    imgTitle02: "Splash & Transitions",
    imgPath02: "/img/projects/ccmd-modules02.png",
    imgTitle03: "Form Elements",
    imgPath03: "/img/projects/ccmd-modules03.png",
    imgTitle04: "Cards",
    imgPath04: "/img/projects/ccmd-modules04.png",
    imgTitle05: "Map + Filter",
    imgPath05: "/img/projects/ccmd-modules05.png",
    descriptionShort: "UI Design",
    descriptionLong:
      "Created UI Design for app modules design tool and framework.",
  },
  {
    id: "008",
    name: "Attendant Interface",
    link: "attendant-interface",
    category: ["web", "ui/ux", "graphic", "web", "email", "video"],
    thumb: "../img/projects/ccmd-modules-thumb@2x.png",
    imgTitle01: "Buttons & Links",
    imgPath01: "/img/projects/attendant-01.png",
    imgTitle02: "Signed Out State",
    imgPath02: "/img/projects/attendant-02.png",
    imgTitle03: "Logged In State",
    imgPath03: "/img/projects/attendant-03.png",
    imgTitle04: "Modal Receipt",
    imgPath04: "/img/projects/attendant-04.png",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Software UI / Styleguide",
    descriptionLong: "Styleguide for an attendant interface for fuel stations.",
  },
  {
    id: "009",
    name: "DPC App",
    slug: "dpc-app-ux",
    category: ["ui/ux", "graphic"],
    thumb: "../img/projects/ccmd-modules-thumb@2x.png",
    imgTitle01: "UX Flow | Login Signup Password",
    imgPath01: "/img/projects/dpc-01.png",
    imgTitle02: "UX Flow | Home Offers",
    imgPath02: "/img/projects/dpc-01.png",
    imgTitle03: "UX Flow | Menu",
    imgPath03: "/img/projects/dpc-02.png",
    imgTitle04: "Interaction Deck | Login",
    imgPath04: "/img/projects/dpc-03.png",
    imgTitle05: "Interaction Deck | Forgot Password",
    imgPath05: "/img/projects/dpc-04.png",
    descriptionShort: "UX Flow + Interaction Deck",
    descriptionLong: "",
  },
  {
    id: "010",
    name: "Gulp Frameworks",
    slug: "gulp",
    category: ["web", "email"],
    thumb: "../img/projects/gulp-thumb@2x.png",
    imgTitle01: "Menu | Web Build",
    imgPath01: "/img/projects/gulp-01.png",
    imgTitle02: "Menu | Email Build",
    imgPath02: "/img/projects/gulp-02.png",
    imgTitle03: "Menu | Environment",
    imgPath03: "/img/projects/gulp-03.png",
    imgTitle04: "Docs | Multi-page Configs",
    imgPath04: "/img/projects/gulp-04.png",
    imgTitle05: "Docs | Variable Data Mapping",
    imgPath05: "/img/projects/gulp-05.png",
    descriptionShort: "Multi-site Preprocessing",
    descriptionLong:
      "Created multiple frameworks using Node, GulpJS, and Nunjucks to facilitate local development and optimization tasks.",
  },
  {
    id: "011",
    name: "Fuel Rewards Site",
    slug: "fr-rapid-prototype",
    category: ["web", "ux/ui"],
    thumb: "/img/projects/fr-logo-thumb@2x.png",
    imgTitle01: "Rapid Prototype | Home Screen",
    imgPath01: "/img/projects/fr-rip-01.jpg",
    imgTitle02: "Rapid Prototype | About Shell",
    imgPath02: "/img/projects/fr-rip-02.jpg",
    imgTitle03: "Rapid Prototype | Activity",
    imgPath03: "/img/projects/fr-rip-03.jpg",
    imgTitle04: "Rapid Prototype | Search & Sort",
    imgPath04: "/img/projects/fr-rip-04.jpg",
    imgTitle05: "Rapid Prototype | Map Filtering",
    imgPath05: "/img/projects/fr-rip-05.jpg",
    descriptionShort: "Rapid Code Prototyping",
    descriptionLong:
      "Designed and coded a rapid mock of the Fuel Rewards website for Rapid Prototyping with Usability Sciences. Updated the content and UX flow based on feedback over serveral sessios. These protoypes informed the live design of the site.",
  },

  {
    id: "012",
    name: "Fuel Rewards Web",
    slug: "fr-css",
    thumb: "/img/projects/fr-logo-thumb@2x.png",
    imgTitle01: "Mega Menu",
    imgPath01: "/img/projects/fr-resp-01.gif",
    imgTitle02: "Multiple Pages",
    imgPath02: "/img/projects/fr-resp-05.jpg",
    imgTitle03: "",
    imgPath03: "",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Responsive CSS",
    descriptionLong:
      "Added responsive functionality to a legacy desktop-only website.",
  },
  {
    id: "013",
    name: "Exxon Email Code",
    slug: "exxon-email",
    thumb: "/img/projects/exxon-logo-thumb@2x.png",
    imgTitle01: "EMR+ Coded Email | Launch Day",
    imgPath01: "/img/projects/emr-email-01.jpg",
    imgTitle02: "EMR+ Coded Email | New Offers",
    imgPath02: "/img/projects/emr-email-02.jpg",
    imgTitle03: "EMR+ Coded Email | ConfigFiles",
    imgPath03: "/img/projects/emr-email-03.jpg",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "HTML Template Code",
    descriptionLong:
      "Created HTML Templates and Configurations for platform-agnostic content updates and optimization. Leveraged Node, Gulp, and Nunjucks to separate content updates from coding.",
  },
  {
    id: "014",
    name: "Shirt Designs",
    slug: "shirt-designs",
    thumb: "/img/projects/shirts-thumb.png",
    imgTitle01: "Hive Records | F Shirt",
    imgPath01: "/img/projects/shirt-hive@2x.png",
    imgTitle02: "Suspicious Records | Diagram Shirt",
    imgPath02: "/img/projects/shirt-suspiscious@2x.png",
    imgTitle03: "Suspicious Records | AUP Shirt",
    imgPath03: "/img/projects/shirt-suspicious2@2x.png",
    imgTitle04: "",
    imgPath04: "",
    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Record Label Shirt Designs",
    descriptionLong:
      "A few logos & shirt concepts created for Hive Records & Suspicious Records labels.",
  },
  {
    id: "015",
    name: "Absinthesizer",
    slug: "absinthesizer-posters",
    thumb: "/img/projects/flyers-absinthesizer-thumb.png",
    imgTitle01: "Absinthesizer 1",
    imgPath01: "/img/projects/flyer-absynthesizer01-20091030.png",
    imgTitle02: "Absinthesizer 4",
    imgPath02: "/img/projects/flyer-absynthesizer04-20100306.png",
    imgTitle03: "Absinthesizer 5",
    imgPath03: "/img/projects/flyer-absinthesizer-05-20100410.png",
    imgTitle04: "Absinthesizer 6",
    imgPath04: "/img/projects/flyer-absinthesizer-06-20100501.png",
    imgTitle05: "Absinthesizer 8",
    imgPath05: "/img/projects/flyer-absinthesizer-08.png",
    descriptionShort: "Concert Posters",
    descriptionLong:
      "Series of concert posters for recurring Absithesizer Event at the Absinthe Lounge.",
  },
  {
    id: "016",
    name: "Folium",
    slug: "folium-posters",
    thumb: "/img/projects/flyers-folium-thumb.png",
    imgTitle01: "Escape from SXSW",
    imgPath01: "/img/projects/flyer-folium-gypsy.png",
    imgTitle02: "Sole & Skyrider Band",
    imgPath02: "/img/projects/flyer-folium-sole.png",
    imgTitle03: "Arts Fest",
    imgPath03: "/img/projects/flyer-folium-peacock-20090404.png",
    imgTitle04: "Live at the Cavern",
    imgPath04: "/img/projects/flyers-folium-cavern.png",
    imgTitle05: "Live at PCL",
    imgPath05: "/img/projects/flyer-folium-pcl.png",
    descriptionShort: "Concert Posters",
    descriptionLong: "Series of concert posters for a band called Folium",
  },
  {
    id: "017",
    name: "Misc",
    slug: "misc-posters",
    thumb: "/img/projects/flyers-misc-thumb.png",
    imgTitle01: "Com Truise",
    imgPath01: "/img/projects/flyer-com-truise.png",
    imgTitle02: "Hive Records",
    imgPath02: "/img/projects/flyer-hive-red.png",
    imgTitle03: "Haujobb",
    imgPath03: "/img/projects/flyer-haujobb.png",
    imgTitle04: "Ascension",
    imgPath04: "/img/projects/flyer-ascension.png",

    imgTitle05: "",
    imgPath05: "",
    descriptionShort: "Concert Posters",
    descriptionLong:
      "Series of concert posters for miscellanous DJ and band events",
  },

  {
    id: "018",
    name: "Album Cover Art",
    slug: "album-art",
    thumb: "/img/projects/albums-thumb.png",
    imgTitle01: "Hologram Dagger - Serrated Spectra",
    imgPath01: "/img/projects/cd-cover-hologramd@2x.png",
    imgTitle02: "grIMP - Square Tide",
    imgPath02: "/img/projects/cd-cover-grimpst@2x.png",
    imgTitle03: "Void Prototype - Uncanny Valley",
    imgPath03: "/img/projects/cd-cover-voidp@2x.png",
    imgTitle04: "Scrap.edx - Collect:Erase",
    imgPath04: "/img/projects/cd-cover-scrapedx-collect@2x.png",

    imgTitle05: "The Belle Auren - Between Hammer & Anvil",
    imgPath05: "/img/projects/cd-cover-belleauren.png",
    descriptionShort: "Album Art",
    descriptionLong: "Music Album Cover Artwork for various releases",
  },
  // {
  //   id: "010",
  //   name: "Album List",
  //   thumb: "../img/projects/thumb@2x.png",
  //   descriptionShort: "Catalog Generator",
  //   descriptionLong:
  //     "Script that creates a catalog from network files and displays groupings based on folder structure.",
  // },
]
